import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dialog, TextField, DialogTitle, DialogContentText, DialogContent, DialogActions, Button, Box, CircularProgress } from '@material-ui/core'
import axios from '../../axios'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../../constants'
import SnackBar from '../../components/snackbar'
import { isValidEmail } from '../../utils'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const ForgotPassword = ({ open, handleClose }) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(null)
  const { enqueueSnackbar } = SnackBar.Consumer()


  const handleSendEmail = async() => {
    if (!isValidEmail(email)) {
      setEmailError('Email non valida!')

    } else {

      try {
        setLoading(true)
        const responseToken = await axios.post('/generate-user-reset-password-token', {
          email,
        })
        const responseEmail = await axios.post('/send-reset-user-password-email', {
          token: responseToken.data.token,
          email,
          name:responseToken.data.name
        })
        enqueueSnackbar('Email inviata correttamente', {
          variant: 'success',
        })
        handleClose()
        
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (error.status === 400) {
          enqueueSnackbar(error.response.data.message, {
            variant: 'error',
          })
        } else {
        enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
          variant: 'error',
        })
      }
    }
    }
  }

  return (
    <Dialog

      open={open}
      onClose={() => {
        setEmail('')
        setEmailError(null)
        handleClose()
      }}
    >
      <Box style={{ padding: '1rem' }}>

        <DialogTitle>Reimposta password</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
        >
          <DialogContentText style={{ fontSize: '0.9rem', marginBottom: '1rem' }}>
            Inserire il tuo indirizzo email, e ti invieremo il link per reimpostare password.
          </DialogContentText>
          <TextField
            error={emailError}
            helperText={emailError}
            onChange={(event) => setEmail(event.target.value)}
            style={{ width: '100%' }}
            required
            id="email"
            name="email"
            placeholder="Email"
            fullWidth
          />
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button style={{ width: '8rem' }} onClick={() => {
            setEmail('')
            setEmailError(null)
            handleClose()
          }} color='default' variant='contained'>Annulla</Button>
          <Button disabled={!email} style={{ width: '8rem' }} onClick={() => email && handleSendEmail()} variant="contained" type="submit" color='primary'>
            {loading ? <CircularProgress style={{ color: 'white' }} size={25} /> : 'Continua'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;